import React, { useContext } from 'react';
import { NavMenu } from './NavMenu';
import { NavSideMenu } from './Navigation/NavSideMenu';
import { UserContext, LoginType } from './UserAccess/UserContext';
import { Button } from 'react-bootstrap';
import useLocalStorage from './Common/useLocalStorage';
import { SidebarContext } from './Navigation/SidebarContext';

const LandingPage = ({ signIn }: { signIn: () => void }) =>
  <main
    id="content"
    role="main"
    className="navbar-sidebar-aside-sm"
    style={{
      backgroundImage: `url(/Login_Page_Background.jpg)`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      height: '100vh',
      width: '100vw',
    }}>
    <header className="navbar fixed-top" style={{ zIndex: 100 }}>
      <div className="container-fluid">
        <img className="m-2" src="/KA-RGB-color_logo.png" alt="Logo" width='100' style={{ minWidth: '15rem', maxWidth: '15rem' }} />
      </div>
    </header>
    <img
      className="w-50 position-absolute start-50 translate-middle"
      style={{ top: '40%' }}
      src="/Constellation_RGB_Subheading_White.png"
      alt="Constellation" />
    <div className="position-absolute start-50 translate-middle" style={{ top: '60%' }}>
      <Button
        className="bg-ka-blue"
        size="lg"
        style={{ fontSize: '1.5rem' }}
        onClick={signIn}>
        Sign In
      </Button>
    </div>
  </main>

const DisabledAlert = () =>
  <div className="alert alert-soft-danger mt-n5 mb-5 mx-n1" role="alert">
    Communication with sites has been interrupted. Please contact Kahler Automation for more details.
  </div>

const SandboxAlert = () =>
  <div className="alert alert-soft-danger mt-n5 mb-5 mx-n1" role="alert">
    Sandbox Testing Version
  </div>

type Props = {
  children: React.ReactNode;
}

const publicRoutes = ['/kahlerlogin', '/siteregistration', '/datasharing/acceptconnection'];

const isPublicRoute = () => {
  const path = window.location.pathname.toLowerCase();
  return publicRoutes.some(route => path.startsWith(route));
};

const Layout: React.FC<Props> = ({ children }) => {
  const { user, busy, login } = useContext(UserContext);
  const [isCollapsed, setIsCollapsed] = useLocalStorage('sidebarCollapsed', false);

  const toggleSidebar = () => setIsCollapsed(!isCollapsed);

  if (busy) return <></>;
  if (user === null && !isPublicRoute()) return <LandingPage signIn={login} />;

  return <SidebarContext.Provider value={{ isCollapsed, toggleSidebar }}>
    <NavMenu />
    {user === null
      ? <main id="content" role="main">
          {children}
        </main>
      : <main id="content" role="main" className="navbar-sidebar-aside-sm">
          <NavSideMenu />
          <div className={`navbar-sidebar-aside-content content-space-t-1 content-space-b-2 px-lg-5${isCollapsed ? ' sidebar-collapsed-content' : ''}`}>
            {user.userType === LoginType.User && user.selectedBusiness?.disabled && <DisabledAlert />}
            {user.userType === LoginType.User && user.selectedBusiness?.sandbox && <SandboxAlert />}
            {children}
          </div>
        </main>}
  </SidebarContext.Provider>
}

export { Layout };
